import { Box, Tab, Tabs } from "@mui/material";
import PropTypes from "prop-types";

const FileManagerTabs = ({ activeTab, onTabChange, exportCount, importCount }) => {
  const handleChange = (event, newValue) => {
    onTabChange(newValue);
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
      <Tabs
        value={activeTab}
        onChange={handleChange}
        aria-label="File operation tabs"
        sx={{
          "& .MuiTab-root": {
            textTransform: "none",
            fontWeight: 500,
            fontSize: "0.95rem",
            minWidth: 120,
          },
        }}
      >
        <Tab
          label={`Exports ${exportCount > 0 ? `(${exportCount})` : ""}`}
          value="exports"
          aria-label="Export files"
        />
        <Tab
          label={`Imports ${importCount > 0 ? `(${importCount})` : ""}`}
          value="imports"
          aria-label="Import files"
        />
      </Tabs>
    </Box>
  );
};

FileManagerTabs.propTypes = {
  activeTab: PropTypes.oneOf(["exports", "imports"]).isRequired,
  onTabChange: PropTypes.func.isRequired,
  exportCount: PropTypes.number.isRequired,
  importCount: PropTypes.number.isRequired,
};

export default FileManagerTabs;
